import { IntentDetail } from "@/features/treasury/treasury";

export default function TreasuryIntentPage() {
  return <IntentDetail />;
}
